import React from 'react';
import Radio from '@material-ui/core/Radio';
import withStyles from '@material-ui/core/styles/withStyles';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioStyles from './RadioStyles';

export default withStyles(RadioStyles)(({
    classes,
    label,
    value,
    onChange,
    checked,
    testId = 'radio',
    isDisabled,
    disableRipple,
    style,
    name,
    alignedTop,
}) => {
    const RadioControlJSX = (
        <Radio
            data-test-id={testId}
            checked={checked}
            onChange={onChange}
            value={value}
            name={name || 'radio button enabled'}
            aria-label='A'
            icon={<FiberManualRecord className={classes.radioUnchecked}/>}
            checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
            classes={{
                checked: classes.checked,
                root: classes.radio,
            }}
            disabled={isDisabled}
            disableRipple={disableRipple}
        />
    );

    return (
        <FormControlLabel
            style={style}
            value={value}
            control={
                alignedTop
                    ? <div style={{ alignSelf: 'start' }}>
                        {RadioControlJSX}
                    </div>
                    : RadioControlJSX
            }
            classes={{
                root: `${classes.labelRoot} ${isDisabled ? classes.disabled : ''}`,
                label: classes.label,
            }}
            label={label}
        />
    );
});
